import Grid from '@mui/material/Unstable_Grid2'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import HiddenDesktop from '../../../../../../shared/styles/HiddenDesktop'
import HiddenMobile from '../../../../../../shared/styles/HiddenMobile'
import UserModal from '../../modals/create/UserModal'
import { DesktopUserInfo } from './DesktopUserInfo'
import { MobileUserInfo } from './MobileUserInfo'
import UserChangePassword, { StateChangePasswordModal } from './UserChangePassword'

function UserInfo({ userId }: { userId: number | null }) {
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userProfileSelected, showForm } = useSelector((state: IRootState) => state.user)

  const [openChangePassword, setOpenChangePassword] = StateChangePasswordModal()

  return (
    <>
      {authUser !== null && userProfileSelected !== null && (
        <>
          {showForm && <UserModal role_id={userProfileSelected.role_id} showBotton={false} />}
          <Grid container spacing={2}>
            <Grid xs={12}>
              <HiddenMobile>
                <DesktopUserInfo openChangePassword={openChangePassword} setOpenChangePassword={setOpenChangePassword} user_id={userId} />
              </HiddenMobile>
              <HiddenDesktop>
                <MobileUserInfo openChangePassword={openChangePassword} setOpenChangePassword={setOpenChangePassword} user_id={userId} />
              </HiddenDesktop>
            </Grid>
          </Grid>
        </>
      )}

      <UserChangePassword user_id={userProfileSelected.id} open={openChangePassword} handleChangeOpen={setOpenChangePassword} />
    </>
  )
}

export default UserInfo
